export default {
    sync_entities_title: "Sincronizar Datos con Zonar",
    sync_entities_account: "Cuenta",
    sync_entities_units: "Unidades",
    sync_entities_subusers: "Subusuarios",
    sync_entities_drivers: "Conductores",
    sync_entities_assets: "Activos",
    sync_entities_asset_subtypes: "Subtipos de Activos",
    sync_entities_process: "Procesar",
    sync_entities_entities_to_sync: "Entidades a Sincronizar",
    sync_entities_success_messages: "Se ha recibido la solicitud de sincronización de entidades. Haga clic aquí para ver el estado de la sincronización.",
    sync_entities_error_messages: "No se han podido sincronizar las entidades",
    sync_entities_asset_types: "Tipos de Activo",
    sync_entities_selected_for: "Debe seleccionarse al menos una entidad para",
    sync_entities_all: "Todos",
    sync_entities_selected: "Selección",
};